import { CdkService, UpdateVehicleBaseDetailsRequest, VehicleDescription } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

export type UpdateVehicleBaseDetailsInput = {
  branchId: number;
  vehicleId: string;
  description: VehicleDescription;
};

const CDK_AUDIT_DATA = {
  userId: 'api-1588',
  userName: 'QS API'
};

export const useUpdateVehicleBaseDetailsMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CdkService.postCdkVehiclesVehicleUpdateBaseDetails>>,
      QueryError,
      UpdateVehicleBaseDetailsInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation((input: UpdateVehicleBaseDetailsInput) => {
    const requestBody: UpdateVehicleBaseDetailsRequest = {
      metadata: {
        auditData: CDK_AUDIT_DATA
      },
      baseDetails: input.description
    } as any;
    return CdkService.postCdkVehiclesVehicleUpdateBaseDetails(input.branchId, input.vehicleId, {
      ...requestBody
    });
  }, options);
